 <!-- 客户档案档案>新增>人员管理 -->
 <template>
  <div id="persons">
    <div class="btns">
      <el-button class="btnItems" v-if="hasPermiss('admin:customer:delCustomerPersonnel')" @click="delBtns()">删除</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:customer:udpateCustomerPersonnel')" @click="modify()">编辑</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:customer:addCustomerPersonnel')" @click="add()">添加</el-button>
    </div>
    <div class="tablebox">
      <div class="glo_Table">
        <el-table
          :height="tableHeight"
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableData"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <el-table-column v-for="(item, index) in tableHead" :key="index" :label="item.name" :prop="item.field" align="center" :show-overflow-tooltip="true" :min-width="item.width"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="addForm">
        <el-form :model="formdata" ref="addForm" :rules="rules" v-if="isShowDialog" label-width="100px" class="dia_form">
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="人员类型:" prop="personnelType">
                <el-select v-model="formdata.personnelType" placeholder="请选择">
                  <el-option label="发件人" value="fa_jian:personnel_type" />
                  <el-option label="收件人" value="shou_jian:personnel_type" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员名称:" prop="name">
                <el-input v-model="formdata.name" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="单位名称:" prop="companyName">
                <el-input v-model="formdata.companyName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12" />
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="tel">
                <el-input v-model="formdata.tel" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码:" prop="phone">
                <el-input v-model="formdata.phone" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remarks">
                <el-input type="textarea" rows="2" v-model="formdata.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
  </div>
</template>
  <script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: {
    myDialog,
    paging,
  },
  props: {
    common: {
      type: Object,
    },
  },
  data() {
    return {
      customerId: this.common.customerId,
      tableHeight: "75vh", //  表格高度
      tableData: [],
      selectTableData: [],
      tableHead: [
        {
          name: "类型",
          field: "personnelTypeShow",
          width: "120",
        },
        {
          name: "人员名称",
          field: "name",
          width: "120",
        },
        {
          name: "单位名称",
          field: "companyName",
          width: "120",
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
        },
        {
          name: "手机号码",
          field: "phone",
          width: "120",
        },

        {
          name: "备注",
          field: "remarks",
          width: "120",
        },
        {
          name: "新增人",
          field: "createUserName",
          width: "120",
        },

        {
          name: "修改人",
          field: "updateUserName",
          width: "120",
        },
      ],
      pageStart: 1,
      pageCount: 0,
      pageTotal: this.$COMMON.pageTotals,
      diaWidth: "50%",
      dialogTitle: "编辑人员信息",
      isShowDialog: false,
      formdata: {
        personnelType: "",
        name: "",
        companyName: "",
        tel: "",
        phone: "",
        remarks: "",
      },
      defaultFormdata: {
        customerId: null,
        name: null,
        personnelType: null,
        companyName: null,
        phone: null,
        remarks: null,
        tel: null,
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        personnelType: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.customerId || "";
      if (to.path == "/Customers/CustomMOD/Edit" && id) {
        this.customerId = id
        this.GetData();
      }
    },
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取管理人员列表
    GetData() {
      let queryData = new Object();
      queryData.pageStart = this.pageStart;
      queryData.pageTotal = this.pageTotal;
      queryData.customerId = this.customerId;
      this.$API.CustomerPersonnelList(queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result?.className || "";
          this.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result?.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---管理人员列表`);
        }
      });
    },
    // 删除
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              personnelIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.personnelIds.push(val.personnelId);
            });
            this.$API.delCustomerPersonnel(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.personnelIds.length > 2) {
                    delReq.personnelIds.map(function (v, i) {
                      num = arr.findIndex(
                        (element) => element.personnelId == v
                      );
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.personnelId == delReq.personnelIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    modify(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.formdata = this.selectTableData[0];
      }
    },
    add() {
      this.formdata.customerId = this.customerId;
      this.isShowDialog = true;
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.GetData();
    },
    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultFormdata) {
            if (this.formdata[key]) {
              eval("param." + key + "='" + this.formdata[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.formdata.personnelId)
            param.personnelId = this.formdata.personnelId;
          if (param.personnelId) {
            // 修改接口
            this.$API.udpateCustomerPersonnel(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.$refs.addForm.resetFields();
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addCustomerPersonnel(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.$refs.addForm.resetFields();
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {
        personnelType: "",
        name: "",
        companyName: "",
        tel: "",
        phone: "",
        remarks: "",
      };
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
  <style scoped lang="less">
#persons {
  margin: 40px 40px;
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
  